module.exports = __webpack_public_path__ + "static/media/animated-loader.e4c551f6.svg";